import { useNavigate } from 'react-router-dom';
import { useReunions } from '../hooks/hooks_index';
import { Loading, MediaImageLoading } from "../components/components_index";
import { useState, useEffect, useMemo } from 'react';
import '../styles/Reunions.css';

export default function Reuninos() {
  const {data: reunions, isLoading, error} = useReunions();
  const navigate = useNavigate();
  const [visibleReunions, setVisibleReunions] = useState([]);

  const reunionList = useMemo(
    () => 
      reunions 
        ? Object.entries(reunions).sort(
            ([,a],[,b]) => Number(b.year) - Number(a.year)
          )
        : [], 
    [reunions]
  );

  useEffect(() => {
    if (!reunions) return;
    async function fetchReunions() {
      const reunions = await Promise.all(
        reunionList
          .filter(([id,reunion]) => reunion.year > 1905)
          .map(async ([id, reunion]) => {  
            return {
              id,
              year: reunion.year,
              img: reunion.main_pic ?? "S_logo_PNG.png"
            };
          })
      );
      setVisibleReunions(reunions);
    }
    fetchReunions();
  }, [reunions, reunionList]);

  if (isLoading) return <Loading/>;
  if (error) return <div>Error loading reunions</div>;

  return (
    <div className='reunions-page'>
      <div className="page-title">Family Reunions</div>
      <div className='reunions-container'>
        <div className='reunions-list'>
          {visibleReunions.map((reunion) => (
            <div 
              className='reunions-item' 
              key={reunion.id} 
              onClick={() => navigate(`/reunion/${reunion.id}`)}
              title={`Visit the ${reunion.year} reunion page`}  
            >
              <MediaImageLoading src={reunion.img} className={`reunions-image`} containerName={'reunions'}/>
              <div className="reunions-subtext">
                {reunion.year} Reunion
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}